module.exports = __webpack_public_path__ + "static/media/bannerTablet@1x.708fa537.png";